<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" acceptLabel="Oui" rejectLabel="Non"></p-confirmDialog> 
<div class="container-fluid">
<div class="row mh-100vh" style="height: 100vh;" #divLoginPage> 
  <div class="col-10 col-sm-8 col-md-6 col-lg-6 offset-1 offset-sm-2 offset-md-3 offset-lg-0 align-self-center d-lg-flex align-items-lg-center align-self-lg-stretch bg-white p-5 rounded rounded-lg-0 my-5 my-lg-0" id="login-block">
    <div>
      <h3 class="text-center mt-0 m-b-15"> 
        <img src="assets/v2/img/CFN-LOGO-Sign-only.svg" height="60" alt="logo">
        Confirmer votre nouvelle adresse e-mail
      </h3>
    
    <div class="center-screen container-login100 bodybg-color">            
            <form action="#" novalidate>
              <div>
                <div class="row">
                  <div class="col-md-10 col-connect-action">
                    <button type="submit" class="btn btn-primary special" (click)="save()">
                      <span class="btn-label">
                        <i class="pi pi-save"></i>
                      </span> Je confirme ma nouvelle adresse e-mail.
                      <span *ngIf="isLoading" class="spinner-border spinner-border-sm" style="color:#B22222;"
                            role="status" aria-hidden="true"></span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
    </div>
  </div>
  </div>
  <div class="col-lg-6 d-flex align-items-end login-bg" id="bg-block">
    <div></div>
  </div>
</div>
</div>
